// extracted by mini-css-extract-plugin
export default {"button":"SkipButton_button__j-mrL","afterButton":"SkipButton_afterButton__pftwf","animate":"SkipButton_animate__2MZ8x","increaseWidth":"SkipButton_increaseWidth__aKHp-"};